import { Box, useColorModeValue } from "@chakra-ui/react";

const ChatContainer = ({ children }) => {
    const backgroundColor = useColorModeValue("white", "gray.800");
    const border = useColorModeValue("gray.200", "gray.700");
    const boxShadow = useColorModeValue("lg", "dark-lg");

    return (
        <Box
            as="section"
            maxW={["98%", "95%", "90%"]}
            h="calc(100dvh - 6rem)"
            mx="auto"
            px={[2, 4, 6]}
            py={1}
            bg={backgroundColor}
            borderColor={border}
            borderWidth="1px"
            borderRadius="xl"
            boxShadow={boxShadow}
            overflow="hidden"
            display="flex"
            flexDirection="column"
        >
            {children}
        </Box>
    );
};

export default ChatContainer;
